import { ReactElement } from "react";

import { styled, Tooltip, tooltipClasses, TooltipProps } from "@mui/material";
import dayjs from "dayjs";

import { ReactComponent as InfoIcon } from "@assets/icons/info.svg";

const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.wolfram,
    color: "black",
    boxShadow: theme.shadows[1],
    fontSize: 11,
    width: 300,
  },
}));

export const withCancelRequestHint = ({
  trigger,
  when,
}: {
  trigger?: ReactElement;
  when?: string;
}) => (
  <LightTooltip
    placement="right"
    arrow
    title={`Note: Request will be automatically accepted on ${dayjs(when)
      .add(3, "day")
      .format("MMM DD, YYYY hh:mm A")} if no action is taken.`}
    slotProps={{
      popper: {
        disablePortal: true,
      },
    }}
  >
    {trigger || <InfoIcon width={16} />}
  </LightTooltip>
);
